import React, { useEffect, useState } from 'react';
import './ScrollTop.css';

const ScrollTop: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      className={`scroll-top ${visible ? 'show' : ''}`}
      aria-label="Yukarı Çık"
      onClick={goTop}
    >
      ↑
    </button>
  );
};

export default ScrollTop; 